<template>
  <v-layout row wrap>
    <v-flex lg12>
      <app-card :fill-height="false">
        <div class="app-card-header">
          <div class="heading-block">
            <h4 class="heading">Color Scheme</h4>
          </div>
        </div>
        <div class="card-body">
          <form ref="radios" class="d-flex">
            <div class="ex-image-radio-btn">
              <input type="radio" value="0" name="color" id="color-1" @change="changeThemeColor($event)">
              <p>Dark</p>
              <label for="color-1">
                <img src="../assets/img/icons/layouts/dark.svg" alt="">
                <span class="checkmark"></span>
              </label>
            </div>
            <div class="ex-image-radio-btn ml-5">
              <input type="radio" value="1" name="color" id="color-2" @change="changeThemeColor($event)">
              <p>Light</p>
              <label for="color-2">
                <img src="../assets/img/icons/layouts/light.svg" alt="">
                <span class="checkmark"></span>
              </label>
            </div>
          </form>
        </div>
      </app-card>
    </v-flex>

    <!-- Success Toaster-->
    <notifications group="success" position="bottom right" :max="toaster.max" width="350">
      <template slot="body" slot-scope="props">
        <div class="default-notification save-notification">
          <a class="close" @click="props.close">
            <v-icon>close</v-icon>
          </a>
          <a class="title">
            <img src="../assets/img/icons/success.svg" alt="">
            {{ props.item.title }}
          </a>
          <p v-html="props.item.text"></p>
        </div>
      </template>
    </notifications>

    <!--Error Toaster-->
    <notifications group="error" position="bottom right" :max="toaster.max" width="350">
      <template slot="body" slot-scope="props">
        <div class="default-notification save-notification">
          <a class="close" @click="props.close">
            <v-icon>close</v-icon>
          </a>
          <a class="title danger">
            <img src="../assets/img/icons/cancel.svg" alt="">
            {{ props.item.title }}
          </a>
          <p v-html="props.item.text"></p>
        </div>
      </template>
    </notifications>
  </v-layout>
</template>

<script>
export default {
  name: 'ProfileSettingsConsole',
  data: () => ({
    toaster: {
      max: 3
    }
  }),
  mounted () {
    this.checkActive()
  },
  methods: {
    checkActive () {
      let radiosList = this.$refs.radios.querySelectorAll('input')
      radiosList.forEach(radio => {
        if (radio.value === this.getThemeColor) radio.checked = true
      })
    },
    changeThemeColor (e) {
      this.$store.dispatch('auth/changeThemeColor', e.target.value).then(() => {
        this.$store.dispatch('auth/getThemeColor').then((res) => {
          if (res === 1) {
            this.$notify({
              group: 'success',
              title: 'Theme Color',
              text: 'Theme Color has been changed !',
              duration: 500,
              speed: 600
            })
          } else {
            this.$notify({
              group: 'error',
              title: 'Theme Color',
              text: 'Theme Color hasn\'t been changed !',
              duration: 500,
              speed: 600
            })
          }
        })
      })
    }
  },
  computed: {
    getThemeColor () {
      return this.$store.state.auth.userInfo.themeColor
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/ProfileSettingsConsole.vue